export const accountContinueButtonText = "Continue";
export const userCreationAlreadyHaveAnAccount = "Already have an account?";
export const clickHereToSignIn = "Click Here to sign in";
export const backButton ="Previous Step";
export const confirmAccountCreation = "Step 3 of 3: Confirm Account Creation";
export const clickHereMessage = "Click here to go to the login page";



/** WEBPACK FOOTER **
 ** ./src/constants/userCreationText.js
 **/